import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { simulationCasesPath } from "./constants";
import type {
  PostSimulationCaseProps,
  SaveSimulationCaseErrors,
  SimulationCase,
  SimulationItemResponse,
} from "./types";

export const postSimulationCase = reactQueryMutationAdapter(
  simulationCasesPath,
  createMutationFetcherFunctionWithShadowError<SaveSimulationCaseErrors>()(
    ({ appGroupId, body }: PostSimulationCaseProps): Promise<SimulationItemResponse<SimulationCase>> =>
      fetch(`/${appGroupId}/conversational/simulation/cases`, "POST", body, undefined, {
        propagateFetchRequestError: false,
      })
  )
);
